import { Rut } from '@components/Rut';
import { type Rut as RutType } from '@utils/rut/types';

import { withCellValue } from '../withCellValue';

const RutCell = withCellValue(({ children }) => {
  return <Rut fullRut={children as RutType} />;
});

export { RutCell };
